module.exports = __webpack_public_path__ + "img/0005.a450e198.jpg";